import DsLink from '@carvana/ds-link';
import { Fragment } from 'react';
import { Footer, FooterWrapper, Pipe } from './MinifiedFooter.styles';

type OwnProps = {
  className?: string;
};

const policies = [
  {
    displayName: 'User Agreement',
    shouldOpenInNewTab: false,
    url: '/terms-of-use'
  },
  {
    displayName: 'Financial and Other Privacy Notices',
    shouldOpenInNewTab: false,
    url: '/financial-and-other-privacy-notices'
  },
  {
    displayName: 'Consumer Privacy Notice',
    shouldOpenInNewTab: false,
    url: '/privacy-policy'
  },
  {
    displayName: 'Do Not Sell or Share My Personal Information',
    shouldOpenInNewTab: false,
    url: 'https://privacy.carvana.com/dont_sell'
  },
  {
    displayName: 'Code of Conduct',
    shouldOpenInNewTab: true,
    url: '/code-of-conduct/'
  },
  {
    displayName: 'Responsible Disclosure',
    shouldOpenInNewTab: false,
    url: '/responsible-disclosure'
  },
  {
    displayName: 'Accessibility',
    shouldOpenInNewTab: false,
    url: '/accessibility'
  }
];

const currentYear = new Date().getFullYear();

export default function MinifiedFooter({ className }: OwnProps) {
  return (
    <FooterWrapper className={className}>
      <Footer>
        <p>Copyright &copy; {currentYear} Carvana, LLC. All Rights Reserved.</p>
        <div className="flex flex-wrap items-center gap-md">
          {policies.map(({ displayName, shouldOpenInNewTab, url }, index) => (
            <Fragment key={displayName}>
              {index > 0 && <Pipe />}
              <DsLink
                data-analytics-attributes={JSON.stringify({
                  text: displayName
                })}
                data-analytics-id="Minified Footer"
                href={url}
                preventVisitedColor
                priority="inverse"
                rel={shouldOpenInNewTab ? 'noopener noreferrer' : undefined}
                size="xs"
                target={shouldOpenInNewTab ? '_blank' : '_self'}
                variant="standalone"
              >
                {displayName}
              </DsLink>
            </Fragment>
          ))}
        </div>
      </Footer>
    </FooterWrapper>
  );
}
